import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const ProviderFavouriteReportsOrNot = (apidata) => async (dispatch) => {
  /*** API Call Action ***/
  const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
  try {
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/provider/HandleFavouriteReports`,
      data: apidata,  
    });

    return response.data; 
  } catch (error) {
    console.error("Error in ProviderFavouriteReportsOrNot:", error);
    return { error: error.message }; 
  }
};




export const ProviderGetAllfavouriteReports =
  (apiData) => async (dispatch) => {
    /*** API Call Action ***/
    try {
      const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
      const response = await axios({
        method: "get",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
          organisationid: storedData?.organisation_id,
        },
        url: `${actionType.environment_url}/api/provider/GetAllfavouriteReports`,
        params: apiData,
      });
      return response.data;
    } catch (error) {
      return error.message;
    }
  };
